import React, { useContext, useState } from "react";
import className from "classnames";
import { Redirect, useLocation } from "react-router-dom";

import LayoutMain from "blocks/layout-main/layout-main";
import { UiContext } from "contexts/ui-context";
import axios from "axios";
import API from "../../utils/api";
import { MainStore } from "../../stores/Main";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePostHog } from "posthog-js/react";

const DashboardRoot = (props) => {
  const location = useLocation();
  const { isCollapsedSidebar } = useContext(UiContext);
  const mainStore = useContext(MainStore);
  const [ready, setReady] = useState(false);
  const posthog = usePostHog();

  // Fetch users profile
  const fetchProfile = React.useCallback(() => {
    axios.all([API.get("/profile"), API.get("/profile/pic")]).then(
      axios.spread((profileR, pic) => {
        mainStore.setProfile(profileR.data);
        if (pic.data.Img && pic.data.Img !== "")
          mainStore.setAvatar(pic.data.Img);
        setReady(true);
        //mainStore.setAccounts(accounts.data.account);
        if (profileR.data.id) {
          posthog?.identify(profileR.data.id);
        } else if (profileR.data.ref) {
          posthog?.identify(profileR.data.ref);
        }
      })
    );
  }, []);

  // On focus of this tab, fetch the profile
  React.useEffect(() => {
    fetchProfile();
  }, []);

  if (!props.isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: location },
        }}
      />
    );
  } else if (mainStore.agency && !mainStore.agencyLinked && ready) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: location, existing: true },
        }}
      />
    );
  } else if (mainStore.userType === "consumer-quick-access" && ready) {
    // Handle consumer-quick-access users
    if (
      !mainStore.acceptedDisclosures &&
      location.pathname !== "/dashboard/disclosures"
    ) {
      return (
        <Redirect
          to={{
            pathname: "/dashboard/disclosures",
            state: { from: location },
          }}
        />
      );
    }
    // Allow consumer-quick-access to view allowed pages
  } else if (
    location.pathname !== "/dashboard/disclosures" &&
    !mainStore.acceptedDisclosures &&
    mainStore.agency &&
    ready
  ) {
    // Handle regular agency users who haven't accepted disclosures
    return (
      <Redirect
        to={{
          pathname: "/dashboard/disclosures",
          state: { from: location },
        }}
      />
    );
  }

  if (ready && location.pathname === "/dashboard/disclosures") {
    return (
      <>
        <div
          className={className("wrapper__inner", {
            "sidebar-active": isCollapsedSidebar,
          })}
        >
          <div className={className({ "is-active": isCollapsedSidebar })}>
            <LayoutMain>{props.children}</LayoutMain>
          </div>
        </div>
      </>
    );
  } else if (
    ready &&
    mainStore.userType !== "consumer-quick-access" &&
    mainStore.appConfig.onboarding_financials === "required" &&
    !mainStore.questionnaire
  ) {
    return (
      <Redirect
        to={{
          pathname: "/questionnaire",
          state: { from: location },
        }}
      />
    );
  } else if (
    ready &&
    mainStore.userType !== "consumer-quick-access" &&
    mainStore.appConfig.onboarding_sentiment === "required" &&
    !mainStore.sentimentQuestionnaire
  ) {
    return (
      <Redirect
        to={{
          pathname: "/sentiment-questionnaire",
          state: { from: location },
        }}
      />
    );
  } else if (
    ready &&
    location.pathname !== "/dashboard/disclosures" &&
    mainStore.acceptedDisclosures &&
    mainStore.profile.first_name !== ""
  ) {
    return (
      <>
        <div
          className={className("wrapper__inner", {
            "sidebar-active": isCollapsedSidebar,
          })}
        >
          <div className={className({ "is-active": isCollapsedSidebar })}>
            <LayoutMain>{props.children}</LayoutMain>
          </div>
        </div>
      </>
    );
  } else if (
    ready &&
    location.pathname === "/dashboard/disclosures" &&
    mainStore.acceptedDisclosures
  ) {
    return (
      <>
        <div
          className={className("wrapper__inner", {
            "sidebar-active": isCollapsedSidebar,
          })}
        >
          <div className={className({ "is-active": isCollapsedSidebar })}>
            <LayoutMain>{props.children}</LayoutMain>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div
        style={{ position: "absolute", width: "100%", height: "100%", left: 0 }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleNotch}
            spin
            className="fast-spin"
            color="#ccc"
            size="2x"
            style={{ opacity: "0.5" }}
          />
        </div>
      </div>
    );
  }
};

export default DashboardRoot;
